import { useMemo } from "react";
import { Box } from "@mui/material";
import { PlaceholderMaterial } from "../PlaceholderMaterial/PlaceholderMaterial";
import { PlanMaterial } from "../PlanMaterial/PlanMaterial";

export function MaterialCardList({
  planDetails,
  area,
  updateArea,
  isAreaSelected,
  materials = [],
  categories = [],
  dismissedCategories = [],
  handleDismissCategory,
  selectedPlaceholder,
  setSelectedPlaceholder,
  handleResetAddItems,
  categoryFilterOptions,
  handleCategoryClick,
  handleOpenCategoryFilter,
  isLoading,
}) {
  const sortedCategories = useMemo(
    () =>
      categories
        ?.toSorted((a, b) => {
          if (a.isRequired !== b.isRequired) {
            return b.isRequired - a.isRequired;
          }
          return a.displayOrder - b.displayOrder;
        })
        ?.filter((cat) => {
          const isDismissed = dismissedCategories.includes(cat.categoryId);
          return isDismissed
            ? !isDismissed
            : !materials.some(
                (material) => cat.categoryId === material.category?.categoryId
              );
        }),
    [categories, materials, dismissedCategories]
  );

  const handleCategoryFilter = (category) => {
    handleResetAddItems();
    handleOpenCategoryFilter();
    setSelectedPlaceholder(category.categoryId);
    const filteredCategory = categoryFilterOptions.find(
      (cat) => cat.categoryId === category.categoryId
    );
    handleCategoryClick(filteredCategory);
  };

  return (
    <Box>
      {materials?.map((item) => (
        <PlanMaterial
          key={item.id}
          item={item}
          area={area}
          updateArea={updateArea}
          planDetails={planDetails}
          isLoading={isLoading}
        />
      ))}
      {sortedCategories?.map((cat) => {
        return (
          <PlaceholderMaterial
            key={cat.categoryId + area.id}
            category={cat}
            isSelected={
              selectedPlaceholder === cat.categoryId && isAreaSelected
            }
            disabled={isLoading}
            preview={area?.preview}
            onClick={() => handleCategoryFilter(cat)}
            onDismiss={() => handleDismissCategory(cat.categoryId, area.id)}
          />
        );
      })}
    </Box>
  );
}
